import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";
import ViewUserSideBar from "./ViewUserSideBar";
import ReactPaginate from "react-paginate";
import { fetchSingleUserDonations } from "../../utils/UserComponents";

const Base_Url = process.env.REACT_APP_BASE_URL;

const UserDonations = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const queryParams = new URLSearchParams(location.search);
  const initialPage = parseInt(queryParams.get("page")) || 1;

  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(initialPage);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  const updateUrlParams = useCallback(
    async (newPage, newLimit) => {
      const searchParams = new URLSearchParams(location.search);
      searchParams.set("page", newPage);
      searchParams.set("limit", newLimit);
      navigate({ search: searchParams.toString() });
    },
    [location.search, navigate]
  );

  useEffect(() => {
    const id = location.pathname.split("/").pop();
    setLoading(true);
    fetchSingleUserDonations(
      id,
      setPosts,
      page,
      limit,
      setTotalPages,
      searchQuery
    );
    updateUrlParams(page, limit);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, [page, searchQuery, limit, location.pathname, updateUrlParams]);

  const handleLimitChange = (e) => {
    const newLimit = parseInt(e.target.value);
    setLimit(newLimit);
    setPage(1);
    updateUrlParams(1, newLimit);
  };

  const handleViewPost = (post) => {
    navigate(`/view/post/${post._id}`);
  };

  const handlePageChange = (selectedPage) => {
    const newPage = selectedPage.selected + 1; // ReactPaginate uses 0-based indexing
    setPage(newPage);
    updateUrlParams(newPage, limit);
  };

  const handleSearch = (e) => {
    setLoading(true);
    setSearchQuery(e.target.value);
    setPage(1);
    updateUrlParams(1, limit);
  };

  return (
    <>
      <Header />
      <div className="flex-screen custom_section user-donations user-posts">
        <ViewUserSideBar />
        <div className="aligned-container 15">
          <div className="custom_container">
            <div className="search-container">
              <div className="topHeading">
                <h2>Donations</h2>
              </div>
              <input
                type="text"
                placeholder="Search donations by title"
                value={searchQuery}
                onChange={handleSearch}
              />
            </div>

            {loading ? (
              <div className="container loading-dots">
                <span>.</span>
                <span>.</span>
                <span>.</span>
              </div>
            ) : (
              <>
                {!loading &&
                  (posts && posts.length > 0 ? (
                    <div className="post-container">
                      {posts.map((post) => (
                        <div className="slide-box post-card" key={post._id}>
                          <div className="slider-image post_slideimg">
                            <img
                              src={`${Base_Url}/assets/postThumbnails/${post.attachment}`}
                              alt=""
                            />
                          </div>
                          <div className="card-content">
                            <h2 className="slider-title post-title">
                              {post.title}
                            </h2>
                            <h4 className="slider-amount">${post.amount}</h4>
                            <p
                              className="description"
                              dangerouslySetInnerHTML={{
                                __html: post.description,
                              }}
                            ></p>
                            <div
                              className="donate-btns"
                              style={{ margin: "10px 0" }}
                            >
                              <button
                                className="donate-btn"
                                onClick={() => handleViewPost(post)}
                              >
                                View
                              </button>
                            </div>
                          </div>{" "}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="post-container">No Donations Found</div>
                  ))}

                {!loading && (
                  <>
                    <div className="blog-paginate">
                      <div className="limit-selection">
                        <label htmlFor="limit">Donations per page: </label>
                        <select
                          id="limit"
                          value={limit}
                          onChange={handleLimitChange}
                        >
                          <option value={5}>5</option>
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                        </select>
                      </div>

                      {posts &&
                        posts.length > 0 &&
                        totalPages &&
                        totalPages > 1 && (
                          <ReactPaginate
                            pageCount={totalPages}
                            onPageChange={handlePageChange}
                            containerClassName="pagination"
                            previousLabel={"<"}
                            nextLabel={">"}
                            breakLabel={"..."}
                            pageClassName={"page-item"}
                            activeClassName={"active"}
                            marginPagesDisplayed={1}
                            pageRangeDisplayed={2}
                            forcePage={page - 1} // Sync with current page
                          />
                        )}
                    </div>
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserDonations;
